"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyEnroll = copyEnroll;
exports.deleteEnroll = deleteEnroll;
exports.exportEnrollJoin = exportEnrollJoin;
exports.exportEnrollList = exportEnrollList;
exports.getEnrollDetail = getEnrollDetail;
exports.getEnrollJoinPage = getEnrollJoinPage;
exports.getEnrollList = getEnrollList;
exports.saveEnroll = saveEnroll;
exports.toggleEnrollStatus = toggleEnrollStatus;
exports.uploadEnrollImage = uploadEnrollImage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 获取报名活动列表
 * @param {Object} query - 查询参数
 */
function getEnrollList(query) {
  return (0, _requestAuth.default)({
    url: '/enrollActivity/list',
    method: 'get',
    params: query
  });
}

/**
 * 导出报名活动列表
 * @param {Object} query - 查询参数
 */
function exportEnrollList(query) {
  return (0, _requestAuth.default)({
    url: '/enrollActivity/export',
    method: 'get',
    params: query,
    responseType: 'blob'
  });
}

/**
 * 获取报名活动详情
 * @param {Number} id - 活动ID
 */
function getEnrollDetail(id) {
  return (0, _requestAuth.default)({
    url: "/enrollActivity/".concat(id),
    method: 'get'
  });
}

/**
 * 保存报名活动（新增或更新）
 * @param {Object} data - 活动数据
 */
function saveEnroll(data) {
  return (0, _requestAuth.default)({
    url: '/enrollActivity',
    method: 'post',
    data: data
  });
}

/**
 * 删除报名活动
 * @param {Number} id - 活动ID
 */
function deleteEnroll(id) {
  return (0, _requestAuth.default)({
    url: "/enrollActivity/".concat(id),
    method: 'delete'
  });
}

/**
 * 启用/禁用报名活动
 * @param {Number} id - 活动ID
 * @param {Number} isEnable - 状态值
 */
function toggleEnrollStatus(id, isEnable) {
  return (0, _requestAuth.default)({
    url: "/enrollActivity/toggleStatus/".concat(id),
    method: 'post',
    data: {
      isEnable: isEnable
    }
  });
}

/**
 * 复制报名活动（主表 + 奖品明细，发券库存按新活动中奖名额重新生成，新活动默认禁用）
 * @param {Number} id - 活动ID
 */
function copyEnroll(id) {
  return (0, _requestAuth.default)({
    url: "/enrollActivity/copy/".concat(id),
    method: 'post'
  });
}

/**
 * 上传报名活动图片
 * @param {File} file - 图片文件
 */
function uploadEnrollImage(file) {
  var formData = new FormData();
  formData.append('file', file);
  return (0, _requestAuth.default)({
    url: '/enrollActivity/uploadImage',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// ===================== 报名明细 =====================

/**
 * 获取报名明细分页列表
 * @param {Object} query - 搜索参数 { enrollId, status, userId }
 */
function getEnrollJoinPage(query) {
  return (0, _requestAuth.default)({
    url: '/enrollActivity/join/page',
    method: 'get',
    params: query
  });
}

/**
 * 导出报名记录
 * @param {Object} query - 搜索参数 { enrollId, status, userId }
 */
function exportEnrollJoin(query) {
  return (0, _requestAuth.default)({
    url: '/enrollActivity/join/export',
    method: 'get',
    params: query,
    responseType: 'blob'
  });
}